import { IconName } from '@billy/design-system'

import { BookkeepingItemType } from '@features/reconciliation/enums/bookkeepingItemType'

export const bookkeepingItemToIcon: Record<BookkeepingItemType, IconName> = {
  [BookkeepingItemType.Invoice]: 'fileText',
  [BookkeepingItemType.ExternalInvoice]: 'fileText',
  [BookkeepingItemType.Bill]: 'banknote',
  [BookkeepingItemType.Posting]: 'shoppingBag',
}
